<template>
  <div class="wrap">
    <div class="banner">
      <div class="text animated fadeIn">
        <p class="icon"></p>
        <p class="h2">产品展示</p>
      </div>
    </div>
    <div class="inner">
      <div class="content">
        <div class="serch">
          <div class="classA">
            <div :class="{ highlight: selectedOption === 'all' }" @click="updateSelection('all')">全部</div>
              <div :class="{ highlight: selectedOption === 'medicalOxygenSystem' }" @click="updateSelection('medicalOxygenSystem')">医用中心制氧系统</div>
              <div :class="{ highlight: selectedOption === 'smallMedicalOxygenSystem' }" @click="updateSelection('smallMedicalOxygenSystem')">小型医用中心供氧系统</div>
              <div :class="{ highlight: selectedOption === 'medicalGasSystem' }" @click="updateSelection('medicalGasSystem')">医用气体系统</div>
            </div>
        </div>
        <div class="product">
          <div v-for="(item, index) in filtProductList" :key="index" class="product-item">
            <div class="productimg">
              <img :src="item.url" alt="" @click="showDeviceDetail(item)">
            </div>
            <div class="producttit">
              <p>{{ item.title }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ProductDetails
      :dialogVisible.sync="dialogVisible"
      :selectedProduct="selectedProduct"
    />
  </div>
</template>

<script>
import ProductDetails from './productDetails.vue'
export default {
  name: 'ProductDisplay',
  components: {
    ProductDetails
  },
  props: {
    scrollTopNum: Number
  },
  data () {
    return {
      dialogVisible: false,
      selectedProduct: null,
      currentPage: 1,
      itemsPerPage: 100000,
      filters: [],
      nameFilter: '',
      selectedOption: 'all',
      filtProductList: [],
      productList: [
        {
          id: 1,
          identification: 1,
          subidentifier: 11,
          url: require('../../assets/images/airsep/product1.png'),
          url1: require('../../assets/images/airsep/product1ap.png'),
          title: '（大型 ）医用中心制氧系统'
        },
        {
          id: 2,
          identification: 1,
          subidentifier: 0,
          url: require('../../assets/images/airsep/product2.jpg'),
          url1: require('../../assets/images/airsep/product2p.jpg'),
          title: '制氧主机'
        },
        {
          id: 3,
          identification: 1,
          subidentifier: 0,
          url: require('../../assets/images/airsep/product3.jpg'),
          url1: require('../../assets/images/airsep/product3ap.png'),
          title: '空压机'
        },
        {
          id: 4,
          identification: 1,
          subidentifier: 0,
          url: require('../../assets/images/airsep/product4.jpg'),
          url1: require('../../assets/images/airsep/product4ap.png'),
          title: '冷干机'
        },
        {
          id: 5,
          identification: 1,
          subidentifier: 0,
          url: require('../../assets/images/airsep/product5.jpg'),
          url1: require('../../assets/images/airsep/product5p.jpg'),
          title: '过滤器'
        },
        {
          id: 6,
          identification: 1,
          subidentifier: 0,
          url: require('../../assets/images/airsep/product6.png'),
          url1: require('../../assets/images/airsep/product6p.png'),
          title: '纯度分析仪'
        },
        {
          id: 7,
          identification: 2,
          subidentifier: 21,
          url: require('../../assets/images/airsep/product7.png'),
          url1: require('../../assets/images/airsep/product7ap.png'),
          title: '小型医用中心供氧系统'
        },
        {
          id: 8,
          identification: 2,
          subidentifier: 22,
          url: require('../../assets/images/airsep/product8.png'),
          url1: require('../../assets/images/airsep/product8p.png'),
          title: '智能控制器'
        },
        {
          id: 9,
          identification: 2,
          subidentifier: 0,
          url: require('../../assets/images/airsep/product9.jpg'),
          url1: require('../../assets/images/airsep/product99p.png'),
          title: '供氧终端3'
        },
        {
          id: 10,
          identification: 2,
          subidentifier: 23,
          url: require('../../assets/images/airsep/product10.png'),
          url1: require('../../assets/images/airsep/product10p.png'),
          title: '供氧终端1'
        },
        {
          id: 11,
          identification: 2,
          subidentifier: 23,
          url: require('../../assets/images/airsep/product11.png'),
          url1: require('../../assets/images/airsep/product11p.png'),
          title: '供氧终端2'
        },
        {
          id: 12,
          identification: 2,
          subidentifier: 22,
          url: require('../../assets/images/airsep/product12.png'),
          url1: require('../../assets/images/airsep/product12p.png'),
          title: '控制器'
        },
        {
          id: 13,
          identification: 3,
          subidentifier: 35,
          url: require('../../assets/images/airsep/product13.png'),
          url1: require('../../assets/images/airsep/product13p.png'),
          title: '气体监控系统'
        },
        {
          id: 14,
          identification: 3,
          subidentifier: 0,
          url: require('../../assets/images/airsep/product14.png'),
          url1: require('../../assets/images/airsep/product14p.png'),
          title: '二级减压箱'
        },
        {
          id: 15,
          identification: 3,
          subidentifier: 33,
          url: require('../../assets/images/airsep/product15.png'),
          url1: require('../../assets/images/airsep/product15p.png'),
          title: '负压管道'
        },
        {
          id: 16,
          identification: 3,
          subidentifier: 33,
          url: require('../../assets/images/airsep/product16.png'),
          url1: require('../../assets/images/airsep/product16p.png'),
          title: '负压吸引终端'
        },
        {
          id: 17,
          identification: 3,
          subidentifier: 0,
          url: require('../../assets/images/airsep/product17.png'),
          url1: require('../../assets/images/airsep/product17p.png'),
          title: '管道接头'
        },
        {
          id: 18,
          identification: 3,
          subidentifier: 32,
          url: require('../../assets/images/airsep/product18.png'),
          url1: require('../../assets/images/airsep/product18p.png'),
          title: '空气压缩机组'
        },
        {
          id: 19,
          identification: 3,
          subidentifier: 34,
          url: require('../../assets/images/airsep/product19.png'),
          url1: require('../../assets/images/airsep/product19p.png'),
          title: '其他气体'
        },
        {
          id: 20,
          identification: 3,
          subidentifier: 0,
          url: require('../../assets/images/airsep/product20.png'),
          url1: require('../../assets/images/airsep/product20ap.png'),
          title: '设备带'
        },
        {
          id: 21,
          identification: 3,
          subidentifier: 32,
          url: require('../../assets/images/airsep/product21.png'),
          url1: require('../../assets/images/airsep/product21p.png'),
          title: '压缩空气管道'
        },
        {
          id: 22,
          identification: 3,
          subidentifier: 32,
          url: require('../../assets/images/airsep/product22.png'),
          url1: require('../../assets/images/airsep/product22p.png'),
          title: '压缩空气终端'
        },
        {
          id: 23,
          identification: 3,
          subidentifier: 31,
          url: require('../../assets/images/airsep/product23.png'),
          url1: require('../../assets/images/airsep/product23p.png'),
          title: '氧气管道'
        },
        {
          id: 24,
          identification: 3,
          subidentifier: 31,
          url: require('../../assets/images/airsep/product24.png'),
          url1: require('../../assets/images/airsep/product24p.png'),
          title: '氧气终端'
        },
        {
          id: 25,
          identification: 3,
          subidentifier: 33,
          url: require('../../assets/images/airsep/product25.png'),
          url1: require('../../assets/images/airsep/product25ap.png'),
          title: '真空机组'
        },
        {
          id: 26,
          identification: 3,
          subidentifier: 31,
          url: require('../../assets/images/airsep/product26.png'),
          url1: require('../../assets/images/airsep/product26ap.png'),
          title: '（大型）医用中心制氧系统'
        }
      ]
    }
  },
  mounted () {
    this.filtProductList = this.productList
  },
  computed: {
    cascaderOptions () {
      const options = []
      const idMap = new Map()
      this.productList.forEach(item => {
        if (!idMap.has(item.identification)) {
          idMap.set(item.identification, {
            value: item.identification,
            label: this.getTitleById(item.identification),
            children: []
          })
          options.push(idMap.get(item.identification))
        }
        if (item.subidentifier !== 0) {
          const parent = idMap.get(item.identification)
          if (!parent.children.some(child => child.value === item.subidentifier)) {
            parent.children.push({
              value: item.subidentifier,
              label: this.getTitleById(item.subidentifier)
            })
          }
        }
      })
      return options
    },
    filteredList () {
      // 先根据 filters 进行筛选
      let list = this.productList.filter(item => {
        if (this.filters.length === 0) return true
        if (this.filters.length === 1) return item.identification === this.filters[0]
        if (this.filters.length === 2) return item.identification === this.filters[0] && item.subidentifier === this.filters[1]
        return false
      })
      // 然后根据 nameFilter 进行筛选
      if (this.nameFilter) {
        list = list.filter(item => item.title.includes(this.nameFilter))
      }
      return list
    },
    paginatedList () {
      const start = (this.currentPage - 1) * this.itemsPerPage
      const end = start + this.itemsPerPage
      return this.filteredList.slice(start, end)
    }
  },
  watch: {},
  methods: {
    handlePageChange (page) {
      this.currentPage = page
    },
    handleFilterChange () {
      this.currentPage = 1
    },
    getTitleById (id) {
      // 根据id返回对应的title，这里你需要自己实现这个函数逻辑
      const titles = {
        1: '医用中心制氧系统',
        2: '小型医用中心制氧系统',
        3: '医用气体系统',
        11: '（大型 ）医用中心制氧系统',
        21: '（小型）医用中心制氧系统',
        22: '控制器',
        23: '供氧终端',
        31: '氧气系统',
        32: '压缩空气系统',
        33: '负压呼吸系统',
        34: '其他气体',
        35: '气体监控系统'
      }
      return titles[id] || '未知分类'
    },
    showDeviceDetail (product) {
      console.log(product)
      this.selectedProduct = product
      this.dialogVisible = true
    },
    updateSelection (option) {
      this.selectedOption = option
      if (option === 'all') {
        this.filtProductList = this.productList
      } else if (option === 'medicalOxygenSystem') {
        const arr = this.productList.filter(item => item.identification === 1)
        this.filtProductList = arr
      } else if (option === 'smallMedicalOxygenSystem') {
        const arr = this.productList.filter(item => item.identification === 2)
        this.filtProductList = arr
      } else if (option === 'medicalGasSystem') {
        const arr = this.productList.filter(item => item.identification === 3)
        this.filtProductList = arr
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 444px;
  margin-top: 76px;
  background: url("../../assets/images/banner2.png") no-repeat center;
  text-align: center;
  overflow: hidden;
  .text {
    display: inline-block;
    margin: 117px auto 0;
  }
  .icon {
    width: 105px;
    height: 105px;
    margin: 0 auto;
    background: url("../../assets/images/banner2-icon.png") no-repeat center;
  }
  .h2 {
    font-size: 30px;
    color: #fff;
    margin-top: 62px;
  }
}
.inner {
  width: 1200px;
  min-height: 550px;
  margin: 20px auto;
  background-color: #f2f2f2;
  padding: 10px;
  .content{
    min-height: 550px;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    .serch{
      height: 55px;
      display: flex;
      flex-direction: column;
      // align-items: center;
      padding: 10px;
      .searchIpt{
        width: 300px;
        margin-left: 10px;
        margin-right: 10px;
      }
      .classA{
        display: flex;
        div{
          padding: 8px 10px;
          background-color: #ffffff;
          border: 1px #6a6a6a55 solid;
          border-radius: 10px;
          margin-right: 5px;
          cursor: pointer;
        }
        .highlight{
          background-color: #00dcd4;
          border: 1px #00dcd4 solid;
          color: #ffffff;
        }
      }
      .classB{
        display: flex;
        margin-top: 5px;
        div{
          padding: 8px 10px;
          background-color: #ffffff;
          border: 1px #6a6a6a55 solid;
          border-radius: 10px;
          margin-right: 5px;
          cursor: pointer;
        }
        .highlight{
          background-color: #00dcd4;
          border: 1px #00dcd4 solid;
          color: #ffffff;
        }
      }
    }
    .product{
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      border-top: 1px #f2f2f2 solid;
      padding: 10px;
      .product-item{
        width: 190px;
        height: 230px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        padding-bottom: 5px;
        .productimg{
          width: 100%;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          img{
            border: 1px solid #fff;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1);
            border-radius: 8px;
            cursor: pointer;
          }
        }
        .producttit{
          width: 100%;
          height: 30px;
          line-height: 30px;
          display: flex;
          justify-content: center;
          p{
            width: 80%;
            font-size: 12px;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
</style>
